
import { Component, OnInit, Input, ViewChildren, QueryList } from '@angular/core';
import { EISTaskSecurity } from 'qmuzik-angular-model';
import { EISTaskSecurityService } from '../../../../shared/service/generated/eistasksecurity.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EISTaskSecurityStandardSearchComponent } from '../eistasksecurity-standard-search/eistasksecurity-standard-search.component';

@Component({
  selector: 'app-eistasksecurity-standard-filter',
  templateUrl: './eistasksecurity-standard-filter.component.html',
  styleUrls: ['./eistasksecurity-standard-filter.component.css'],
  providers: [
    {
    provide: NG_VALUE_ACCESSOR,
    useExisting: EISTaskSecurityFilterComponent,
    multi: true
  }]  
})
export class EISTaskSecurityFilterComponent implements OnInit, ControlValueAccessor {
  //note: array of all the filters. each entry represents and criteria, with or criteria between them
  public filters: EISTaskSecurity[] = [];
  public filtersSaved: EISTaskSecurity[] = [];
  public searchModeFilterValue: string = "";

  @Input("Visible") visible: boolean;
  @Input("DisplayedInModelStateList") public displayedInModelStateList: boolean = false;
  @Input("ColumnsInList") public columnsInList: boolean = false; 
  @Input("IsInLeftRegion") public isInLeftRegion: boolean = false;

  @ViewChildren(EISTaskSecurityStandardSearchComponent) searchChildren: QueryList<EISTaskSecurityStandardSearchComponent>;

  constructor(private eISTaskSecurityService: EISTaskSecurityService) {   
  }

  ngOnInit() {     
  }

  //note: add another search "object" representing an or
  AddOr(){
    this.filters.push(this.eISTaskSecurityService.CreateForFilter()); 
    this.filtersSaved.push(this.eISTaskSecurityService.CreateForFilter()); 
  }

  //note: expand all search filters
  ExpandAll(){
    this.searchChildren.forEach((child) => { child.searchModeExpanded = true; })
  }

  //note: collapse all search filters
  CollapseAll(){
    this.searchChildren.forEach((child) => { child.searchModeExpanded = false; })
  } 

  //note: event that is fired when a filter's value has been changed
  filterValueChanged(eventData){
    let eISTaskSecurity: EISTaskSecurity = eventData["ModelState"];
    let index: number = eventData["Index"];

    //update the filter value
    //note: this looks funny, but we get a circular reference if we change the filters array. it will cause the ngFor to re-evaluate
    this.filtersSaved[index] = eISTaskSecurity;

    //therefore, we do the long road...there may be a better way
    Object.keys(this.filters[index]).forEach(key => {
      if(this.filters[index][key] !== eISTaskSecurity[key]){
        this.filters[index][key] = eISTaskSecurity[key]
      }
    });

    //note: hallo all reactive forms, the filter has been changed
    if (typeof this.onChange === "function") { 
      this.onChange(this.filtersSaved);
    }  

    this.BuildFilterDisplayValue();
  }

  //note: build the string that will be displayed as the filter value
  BuildFilterDisplayValue(){
     // let filterValue: string = "";
    //clear the complete filter and rebuild
    this.searchModeFilterValue = "";

    //note: use the search controls to display a filter that the user can see
    this.searchChildren.forEach((child) => { 
      if(child.searchModeFilterValue){
        if(child.searchModeFilterValue != ""){
          if(this.searchModeFilterValue === ""){
            this.searchModeFilterValue += child.searchModeFilterValue;
          }
          else{
            this.searchModeFilterValue += " || " + child.searchModeFilterValue;
          }
        }
      }
    })

    // for(var k = 0; k < this.filtersSaved.length; k++)
    // {
    //   filterValue = "";

    //   let keys = Object.keys(this.filtersSaved[k]);
    //   for(var i = 0; i < keys.length; i++ ){
    //     if(
    //           (this.filtersSaved[k][keys[i]] !== undefined) 
    //             &&
    //           (this.filtersSaved[k][keys[i]] !== null) 
    //             &&
    //           (this.filtersSaved[k][keys[i]] !== "") 
    //         ){
    //       //get the operator
    //       let operator: string = Reflect.getMetadata("Operator", this.filtersSaved[k], keys[i]);

    //       //check if there is any dependsonproperties (foreign key values)
    //       let dependsOnProperties = Reflect.getMetadata("DependsOnProperties", this.filtersSaved[k], keys[i]);
    //       if(dependsOnProperties !== undefined){
    //         for(var j = 0; j < dependsOnProperties.length; j++){
    //           if(operator !== undefined){
    //             if(operator !== null){
    //               if(operator !== ""){
    //                 if(filterValue === ""){
    //                   filterValue += "(" + dependsOnProperties[j] + " " + operator + " '" + this.filtersSaved[k][dependsOnProperties[j]] + "')";
    //                 }
    //                 else{
    //                   filterValue += " && (" + dependsOnProperties[j] + " " + operator + " '" + this.filtersSaved[k][dependsOnProperties[j]] + "')";
    //                 }
    //               }
    //             }
    //           }
    //         }
    //       }
    //       else{
    //         if(operator !== undefined){
    //           if(operator !== null){
    //             if(operator !== ""){
    //               if(filterValue === ""){
    //                 filterValue += "(" + keys[i] + " " + operator + " '" + this.filtersSaved[k][keys[i]] + "')";
    //               }
    //               else{
    //                 filterValue += " && (" + keys[i] + " " + operator + " '" + this.filtersSaved[k][keys[i]] + "')";
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }

    //   if(this.searchModeFilterValue === ""){
    //     this.searchModeFilterValue += filterValue;
    //   }
    //   else{
    //     this.searchModeFilterValue += " || " + filterValue;
    //   }

    // }     
  }

  //note: remove all the defined filters
  Clear(){
    this.filters = [];
    this.filtersSaved = [];
    this.searchModeFilterValue = "";

    //note: let the parent know that filters has been cleared
    this.onChange(null);
  }

  //note: implementation of controlvalueaccessor interface
  //note: each component will in itself become a reactive form control
  writeValue(obj: any): void{
    //filters are set internally
  }
  private onChange;
  registerOnChange(fn: any): void{
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void{}
  setDisabledState(isDisabled: boolean): void{}

}


